import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BrandService } from 'app/services/models/brand.service';
import { CompanyService } from 'app/services/models/company.service';
import { DeviceService } from 'app/services/models/device.service';
import { KindService } from 'app/services/models/kind.service';
import { PersonService } from 'app/services/models/person.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-update-device-dialog',
  templateUrl: './update-device-dialog.component.html',
  styleUrls: ['./update-device-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class UpdateDeviceDialogComponent implements OnInit {
  @Input() data: { id: number };
  deviceForm: FormGroup;

  device: any = {};
  brands: any[];
  kinds: any[];
  companies: any[];
  companyPersons: any[];

  constructor(
    private brandService: BrandService,
    private fb: FormBuilder,
    private kindSerivce: KindService,
    private companyService: CompanyService,
    public activeModal: NgbActiveModal,
    private deviceSerivce: DeviceService,
    private personSerivce: PersonService,
    private toastrService: ToastrService,
    private modalService: NgbModal) {
    this.deviceForm = this.fb.group({
      companyId: [null, Validators.required], // Tek firma seçimi
      companyPersonId: [null, Validators.required],
      brandModelId: [null, Validators.required],
      kindId: [null, Validators.required],
      seriNo: ['', Validators.required],
      period: [null],
      description: [null] // Birden fazla ürün formu
    });
  }

  async ngOnInit() {
    await this.getAllBrand();
    await this.getAllKinds();
    await this.getAllCompaines();

    this.deviceForm.get('companyId').valueChanges.subscribe((companyId) => {
      if (companyId) {
        this.getAllCompanyPersons(companyId);
      }
    });

    if (this.data.id) {
      await this.getByIdDevice(this.data.id)
    }
  }

  async getByIdDevice(id) {
    const data = await this.deviceSerivce.getByIdDevice(id);
    console.log(data);
    this.device = data;
    this.deviceForm.patchValue({
      companyId: this.device.companyId,
      companyPersonId: this.device.companyPersonId,
      brandModelId: this.device.brandModelId,
      kindId: this.device.kindId,
      seriNo: this.device.seriNo,
      period: this.device.period,
      description: this.device.description
    });
    this.deviceForm.get('companyId').valueChanges.subscribe((companyId) => {
      if (companyId) {
        this.getAllCompanyPersons(companyId);
      }
    });
  }

  searchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.name?.toLowerCase().includes(term) || item.brandName?.toLowerCase().includes(term);
  }

  async getAllKinds() {
    const data = await this.kindSerivce.getAllKinds('', 0, 100, 13);
    console.log(data);
    this.kinds = data.types;
  }

  async getAllCompaines() {
    const data = await this.companyService.getAllCompany('', 0, 1000);
    console.log(data);
    this.companies = data.companies;
  }

  async getAllCompanyPersons(companyId) {
    const data = await this.personSerivce.getAllCompaniesPersons(0, 1000, companyId);
    this.companyPersons = data.persons;
    console.log(data);
  }

  async getAllBrand() {
    const data = await this.brandService.getBrands();
    // flatMap kullanarak tek katmanlı bir dizi oluşturuyoruz
    this.brands = data.flatMap(brand =>
      brand.brandModels.map(model => ({
        id: model.id,                // Modelin ID'sini ekliyoruz
        name: model.modelName,        // Model ismi
        brandName: brand.brandName    // Grup başlığı olarak marka ismi
      }))
    );
    console.log(this.brands);
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async onSumbit() {
    console.log(this.deviceForm.value);
    if (this.deviceForm.valid) {
      const data = await this.deviceSerivce.updateDevice(
        this.device.id,
        this.deviceForm.value.brandModelId,
        this.deviceForm.value.seriNo,
        this.deviceForm.value.period,
        this.deviceForm.value.kindId,
        this.deviceForm.value.companyId,
        this.deviceForm.value.companyPersonId,
        true, true, this.deviceForm.value.description);
        if(data.status == true){
          this.closeModal();
          this.toastrService.success(data.message);
        }else{
          this.toastrService.error(data.message);
        }
    }
  }
}
